import React from 'react';
import classNames from 'classnames';
import { getLabelClassName } from '~/utils/getLabelClassName';
import { useProductContext } from './productResultContext';

export interface ProductResultImageLabelsProps {
    text: string;
    type: string | undefined;
    className?: string;
}

export const ProductResultImageLabel: React.FC<ProductResultImageLabelsProps> = ({ text, type, className }) => {
    const { style } = useProductContext();
    return (
        <li
            className={classNames({
                [style.label]: true,
                [getLabelClassName(style, type)]: type !== undefined,
                className: className !== undefined,
            })}
        >
            {text}
        </li>
    );
};
